import { FormSelectId, FormSelectIdProps } from '@nexelem/form-components';
import { useCustomTranslation } from '../../../hooks';
import { useOrderNumbers } from '../../../queryHooks/useOrderNumbers';
import { OrderListView } from '@nexelem/api';

type FormOrderNumberSelectProps = Omit<FormSelectIdProps, 'label' | 'options' | 'placeholder'>;

const hasSupplierNumber = (
  order: OrderListView,
): order is OrderListView & { supplierNumber: NonNullable<OrderListView['supplierNumber']> } => !!order.supplierNumber;

export const FormOrderNumberSelect = (props: FormOrderNumberSelectProps) => {
  const { t, tWrapper } = useCustomTranslation('warehouse.outboundDeliveries.filters');
  const { data, isLoading } = useOrderNumbers();

  const options = data?.filter(hasSupplierNumber).map(({ supplierNumber }) => {
    return { id: supplierNumber, label: supplierNumber };
  });

  return (
    <FormSelectId
      {...props}
      label={tWrapper('orderNumber')}
      loading={isLoading}
      options={options}
      placeholder={t('components.filters.searchOrSelect')}
    />
  );
};
